import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { identifyMixPanelUser } from 'utils/analytics';
import {
  getPermissionFromRoute,
  UserHasPermission,
} from 'utils/auth/roles-and-permissions';

import {
  useCheckCompanyUser,
  useGetCompanyLogo,
  useGetUserInfo,
} from '@/modules/auth/apiHooks';
import { Button, Typography } from '@/shared/components/atoms';
import routes, { publicRoutes } from '@/shared/constant/routes';
import { Layout } from '@/shared/hocs';
import { useGetOnboardingStatus } from '@/shared/hooks/apiHooks';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import useAuth from './useAuth';

import Loading from '~/images/shared/Loading.svg';

// todo : need to refactore this file
const ProtectRoute = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation('common');
  const { pathname, back, push } = useRouter();
  const {
    userLoading,
    user,
    updateUser,
    updateSubscriptionType,
    updateOnboardingChecks,
  } = useAuth();
  // when page is loading (this state controled from layout)
  const [isLoadingPage] = useStore((store) => store?.isLoadingPage);

  const { action } = getPermissionFromRoute(pathname);
  const hasPermission = UserHasPermission({ action, role: user?.userGroupId });

  // check if user exists and is pending
  const { data: checkCompanyUser, isLoading: isCheckingUser } =
    useCheckCompanyUser();

  //check if 0 because it might be undefined before updateUser is called
  const isNewUser = user && user.companyUser === 0;

  // get user info with subscription
  const { data: userInfo, isLoading: isUserInfoLoading } = useGetUserInfo(
    !!user?.companyUser
  );

  const { data: onboardingChecks } = useGetOnboardingStatus(
    !!user?.companyUser
  );

  useEffect(() => {
    if (onboardingChecks) {
      updateOnboardingChecks(onboardingChecks);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardingChecks]);

  useEffect(() => {
    if (checkCompanyUser)
      updateUser({
        companyUser: checkCompanyUser?.companyUser ?? 0,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkCompanyUser]);

  useEffect(() => {
    if (userInfo) {
      updateUser(userInfo);
      updateSubscriptionType(userInfo.subscription ?? null);
      identifyMixPanelUser(userInfo);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  // update company logo
  const { data: companyLogo } = useGetCompanyLogo(user?.companyId ?? null);
  useEffect(() => {
    if (companyLogo) {
      updateUser({ companyLogo: companyLogo?.logo });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyLogo]);

  // redirect to home page for pending users
  useEffect(() => {
    if (isNewUser && pathname !== routes.createCompany)
      push(routes.createCompany);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewUser, pathname]);

  //  allow user to pass if they have permission,
  // or allow them to access create company if they're pending
  if ((isNewUser && pathname === routes.createCompany) || hasPermission) {
    return <div>{children}</div>;
  }

  // if not found page
  if (
    !isNewUser &&
    !isCheckingUser &&
    (pathname === '/_error' ||
      pathname === '/404' ||
      pathname === '/500' ||
      publicRoutes.includes(pathname))
  ) {
    return <div>{children}</div>;
  }

  // TODO:: add loading component
  if (userLoading || isLoadingPage || isCheckingUser || isUserInfoLoading) {
    // hide header  to prevent call api requests in header
    return (
      <Layout seoData={{ title: 'aydi' }} withHeader={false}>
        <Loading className='animate-spin ' />
        {/* <LoadingWrapper loading={userLoading} /> */}
      </Layout>
    );
  }

  // TODO:: add design for unauthorized
  return (
    <Layout seoData={{ title: 'aydi' }} withHeader={false}>
      <div className='flex h-screen w-full items-center justify-center'>
        <div className='flex flex-col items-center'>
          <Typography
            variant='body1'
            weight='bold'
            className='mb-24 text-center'
          >
            {t('not-authorized')}
          </Typography>
          <Button onClick={() => back()}>Back</Button>
        </div>
      </div>
    </Layout>

    // <ContentWrapper>
    //   <LoadingWrapper loading={userLoading}>
    //     <div className='site-layout-content center-content'>
    //       <Result
    //         status='403'
    //         title='403'
    //         subTitle='Sorry, you are not authorized to access this page.'
    //         extra={
    //           <Button onClick={() => back()} type='primary'>
    //             Back
    //           </Button>
    //         }
    //       />
    //     </div>
    //   </LoadingWrapper>
    // </ContentWrapper>
  );
};

export default ProtectRoute;
